import { LIST_ITEM_LOCAL_KEY } from '../constants';
const getItemListId = (listName, queryId) => {
  if (queryId) return queryId;
  if (!listName || typeof localStorage === 'undefined') return '';
  const localListName = `${LIST_ITEM_LOCAL_KEY}${listName}`;
  return localStorage.getItem(localListName) || '';
};
export default getItemListId;
//# sourceMappingURL=get-item-list-id.js.map